const isProd = false;
export const localToken = "28db4e66b070ce5f6f445f2a713ce1adbe07d274";
export const BASE_URL = isProd ? "https://hud.mvrc.co.in" : "https://newclinic.mvrc.co.in";
export const hudLoginApiUrl = `${BASE_URL}/api-token-auth/`;
export const hudMachinesApiCRUDUrl = `${BASE_URL}/api/machines/`;
export const hudMedicineApiCRUDUrl = `${BASE_URL}/api/medicine/`;
export const newHudGetMedicineTabletsApiUrl = `${BASE_URL}/api/medicines-tablets`;
export const newHudGetMedicineOintmentsApiUrl = `${BASE_URL}/api/medicines-ointments`;
export const newHudPatientApiCRUDUrl = `${BASE_URL}/api/patient/`;
export const newClinicApprovalPatientApiCRUDUrl = `${BASE_URL}/clinic/approval-images/`;
// Ex: hud/patient/<patient-id>/history/
// Ex: hud/patient/<patient-id>/photos/
// Ex: hud/patient/<patient-id>/pdfs/
// Ex: hud/patient/<patient-id>/add-package/
// Ex: hud/patient/<patient-id>/update-package/<package-id>/
// Ex: hud/patient/<patient-id>/ointments/
// Ex: hud/patient/<patient-id>/tablets/
// Ex: hud/patient/<patient-id>/add-medicine/
// Ex: hud/patient/<patient-id>/unique_photo_date/

export const patientPackageApprovalImageUrl = `${BASE_URL}/clinic/approval-images/`;
export const newClinicHudPackageApiCRUDUrl = `${BASE_URL}/clinic/package/`;
export const newClinicHudDoseApiCRUDUrl = `${BASE_URL}/clinic/dose/`;
export const newHudPackageApiCRUDUrl = `${BASE_URL}/api/package/`;
// Ex: `${BASE_URL}/api/package/<Package-ID>/add-comment/`;
// Ex: `${BASE_URL}/api/package/<Package-ID>/doses/`; // To GET Doses
// Ex: `${BASE_URL}/api/package/<Package-ID>/dose/<dose-id>/`; // To PATCH & DELETE Dose
// Ex: `${BASE_URL}/api/package/<Package-ID>/dose/<dose-id>/add-comment/`; // To ADD comment
// Ex: `${BASE_URL}/api/package/<Package-ID>/add-dose/`; // To ADD Dose
export const newHudDoctoViewPatchUrl = `${BASE_URL}/api/doctor-view-storage-patch/`;
export const newHudAddPatintPackageInvoiceUrl = `${BASE_URL}/api/package-invoice/`;

export const clinicDoctorView = `${BASE_URL}/api/doctor-view-hud/`;
// Ex: `${BASE_URL}/api/doctor-view-hud/<branch>`;

export const todayFilteredPatientsList = `${BASE_URL}/api/todays-full-body-list?branch_name=`;
// Ex: `${BASE_URL}/api/todays-full-body-list?branch_name=Indore&package_type=FULL BODY`;

export const patientSearch = `${BASE_URL}/api/patient-search/`;
export const requestVideoCallApi = `${BASE_URL}/vedio-call/request-call/`;
export const acceptVideoCallApi = `${BASE_URL}/vedio-call/accept-call/`;
// `${BASE_URL}/vedio-call/accept-call/<video-call-id>/`;
export const onGoingVideoCallLogsApi = `${BASE_URL}/vedio-call/pending-calls/`;

// enquiry APIs
export const enquiriesCRUDApi = `${BASE_URL}/api/enquiry-list/`;

// New TPT machine APIs
export const newTptMachineApiUrl = `${BASE_URL}/machine/tpt/`;
// Ex: `${BASE_URL}/machine/tpt/?branch_name=<branch>`; // To GET the center's TPT machine
// Ex: `${BASE_URL}/machine/tpt/<machine-id>/start-dose/`; // To POST { dose_id } and unlock the machine
